var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"input-button light",attrs:{"type":"button","tabindex":"-1"},on:{"click":function($event){return _vm.$emit('click')},"mousedown":function($event){return _vm.onMouseDown($event)}}},[_c('i',{class:_vm.iconClass})])}
var staticRenderFns = []

export { render, staticRenderFns }